// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';

import { Separator } from '../../../../atoms';

import { Banks } from './banks';

export const Root = styled.div`
  color: ${props => props.theme.colors.black};
`;


export function SafetypayOnlineForm(): Node {
  const allFeatures = useAllFeatures();

  return (
    <Root>
      <IfFeature allFeatures={allFeatures} wanted="display_safetypay_online_instructions">
        <p>
          Al elegir la opción trasferencia en línea, tendrás 2 hrs para finalizar tu pago dentro de la banca en línea
          seleccionada.
        </p>
        <Separator size={4} direction="vertical" />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_safetypay_online_banks">
        <Banks />
        <Separator size={4} direction="vertical" />
      </IfFeature>
    </Root>
  );
}
